import React from "react";
import { Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import NavigationButton from "../navigation_button";
import AlertCircleIcon from "../AlertCircleIcon";

interface DeleteConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  open,
  onCancel,
  onConfirm,
  title = "Confirm Delete?",
  message = "All the data added in this particular market will be deleted and this action cannot be undone. Are you sure you want to delete?",
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      closable={false}
      centered
    >
      <div className="flex flex-col items-start justify-start gap-y-6 py-2">
       <AlertCircleIcon/>
        <div className="text-left">
          <p className="text-[#1d2939] text-base font-medium font-['Inter'] leading-normal">{title}</p>
          <p className="text-[#475467] text-[13px] font-normal font-['Inter'] leading-[19px]">{message}</p>
        </div>
        <div className="flex justify-end gap-2 w-full mt-4">
        <NavigationButton onClick={onCancel} label="Cancel" type="text" />
           
          
          <button
            onClick={onConfirm}
            className="bg-[#d92d20] hover:bg-[#b42318] text-white text-sm font-medium px-5 py-2 rounded-md"
          >
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
